module.exports = __webpack_public_path__ + "img/title_digital.e3b22068.svg";